import { ThemeTypography } from "types/theme";

export const typography: ThemeTypography = {
  desktop: {
    title1: {
      fontSize: "26px",
      lineHeight: "32px",
      fontWeight: "500",
    },
    subtitle1: {
      fontSize: "13px",
      lineHeight: "16px",
      fontWeight: "700",
    },
    subtitle2: {
      fontSize: "20px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    body1: {
      fontSize: "18px",
      lineHeight: "32px",
      fontWeight: "400",
    },
    body2: {
      fontSize: "16px",
      lineHeight: "18px",
      fontWeight: "400",
    },
    body3: {
      fontSize: "16px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    body4: {
      fontSize: "15px",
      lineHeight: "18px",
      fontWeight: "500",
    },
    body5: {
      fontSize: "13px",
      lineHeight: "18px",
      fontWeight: "400",
    },
    body6: {
      fontSize: "14px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    body7: {
      fontSize: "13px",
      lineHeight: "18px",
      fontWeight: "500",
    },
    link1: {
      fontSize: "18px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    checkbox: {
      fontSize: "13px",
      lineHeight: "18px",
      fontWeight: "500",
    },
  },
  mobile: {
    title1: {
      fontSize: "26px",
      lineHeight: "32px",
      fontWeight: "500",
    },
    subtitle1: {
      fontSize: "13px",
      lineHeight: "16px",
      fontWeight: "700",
    },
    subtitle2: {
      fontSize: "20px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    body1: {
      fontSize: "18px",
      lineHeight: "32px",
      fontWeight: "400",
    },
    body2: {
      fontSize: "16px",
      lineHeight: "18px",
      fontWeight: "400",
    },
    body3: {
      fontSize: "16px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    body4: {
      fontSize: "15px",
      lineHeight: "18px",
      fontWeight: "500",
    },
    body5: {
      fontSize: "13px",
      lineHeight: "18px",
      fontWeight: "400",
    },
    body6: {
      fontSize: "14px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    body7: {
      fontSize: "13px",
      lineHeight: "18px",
      fontWeight: "500",
    },
    link1: {
      fontSize: "18px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    checkbox: {
      fontSize: "13px",
      lineHeight: "18px",
      fontWeight: "500",
    },
  },
};
